import React from 'react'
import { renderRoutes, RouteConfig } from 'react-router-config'

export interface ChildRouteConfig extends RouteConfig {
	path: string; // 源码里的定义为string|string[] 这里改为只有string 避免和menu item的key的类型相冲突
	routes?: ChildRouteConfig[];
}

class ChildLayout extends React.Component<any> {
	render() {
		const childRoutes: ChildRouteConfig[] = this.props.route.routes
		return (
			<>{renderRoutes(childRoutes)}</>
		)
	}
}

export default ChildLayout